import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/paciente-busca`

    return {
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        realocar(id, params) {
            return repository.put(`${baseUrl}/realocar/${id}`, params)
        },
        destroy(faaId) {
            return repository.delete(`${baseUrl}/${faaId}`)
        },
    }
}